// FIXME: We are not importing via `~utils` due to a circular dependency
import { translate } from "utils/string-table";

export class FeedbackModel {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _feedback?: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(feedback: any = {}) {
    this._feedback = feedback;
  }
  get adminName(): string {
    return this._feedback?.["admin-name"];
  }
  get subName(): string {
    return this._feedback?.["sub-name"];
  }
  get rating(): ExperienceRating | undefined {
    return this._feedback?.["rating"];
  }
  get comments(): string {
    return this._feedback?.["comments"] || "";
  }
  get preferred(): boolean {
    return this._feedback?.["is-preferred"] || "";
  }
  get subId(): string {
    return this._feedback?.["sub-id"] || "";
  }

  get reasons(): string[] {
    return this._feedback?.["reasons"] || [];
  }
  get isBlocked(): boolean {
    return this._feedback?.["is-blocked"] || false;
  }

  static getReasonsDisplayList(reasons: string[]): string[] {
    return Object.keys(FEEDBACK_REASONS)
      .filter((feedbackReason) => reasons.includes(feedbackReason))
      .map((feedbackReason) => FEEDBACK_REASONS[feedbackReason as keyof typeof FEEDBACK_REASONS]);
  }

  static capitalizeFirstLetter(value: string): string {
    return value.slice(0, 1) + value.slice(1, value.length).toLowerCase();
  }
}

export type ExperienceRating = "RATING_POSITIVE" | "RATING_NEUTRAL" | "RATING_NEGATIVE";

export const EXPERIENCE_LIST: Record<ExperienceRating, string> = {
  RATING_POSITIVE: translate("POSITIVE_LABEL"),
  RATING_NEUTRAL: translate("NEUTRAL_LABEL"),
  RATING_NEGATIVE: translate("NEGATIVE_LABEL"),
};

export const REASONS = {
  Reliability: "REASON_RELIABILITY",
  Disengaged: "REASON_DISENGAGED",
  Directions: "REASON_DIRECTIONS",
  Management: "REASON_MANAGEMENT",
  Attitude: "REASON_ATTITUDE",
  Safety: "REASON_SAFETY",
  Phone: "REASON_PHONE",
  Flexible: "REASON_FLEXIBLE",
  Knowledgeable: "REASON_KNOWLEDGEABLE",
  Other: "REASON_OTHER",
} as const;

type FeedbackReasonKeys = Exclude<
  keyof typeof REASONS,
  "Phone" | "Flexible" | "Knowledgeable" | "Other"
>;

export const FEEDBACK_REASONS: Record<(typeof REASONS)[FeedbackReasonKeys], string> = {
  REASON_RELIABILITY: translate(REASONS.Reliability),
  REASON_DISENGAGED: translate(REASONS.Disengaged),
  REASON_DIRECTIONS: translate(REASONS.Directions),
  REASON_MANAGEMENT: translate(REASONS.Management),
  REASON_ATTITUDE: translate(REASONS.Attitude),
  REASON_SAFETY: translate(REASONS.Safety),
};
